export enum ErrorCodes {
  ZERO_WEIGHT_ORDER_PRESENT = "ZERO_WEIGHT_ORDER_PRESENT",
}
